import { create } from 'zustand';

export interface ICustomerInfo {
  customer_name: string;
  customer_phone: string;
  // 추가정보
  createdAt?: string | null;
  messageId?: number | null;
  messageReceiverId?: number | null;
}

export interface ICheckedCustomerInfos {
  checkedCustomerInfos: ICustomerInfo[];
  setCheckedCustomerInfos: (row: ICustomerInfo[]) => void;
}

export const useCheckedCustomerInfos = create<ICheckedCustomerInfos>(set => ({
  checkedCustomerInfos: [],
  setCheckedCustomerInfos: checkedCustomerInfos => set({ checkedCustomerInfos }),
}));
